import LoadingOverlay from './loading-overlay.js';
import ElementClassHandler from './utils/element-class-handler.js';
import * as constants from './config/constants.js';


export default class BankDetails {
   constructor() {
         this.loadingOverlay = new LoadingOverlay;
         this.elementClassHandler = new ElementClassHandler;
         this.container = document.getElementById('pcsi_block');
         this.section = document.getElementById('pcsi-section');
         this.contractSummaryLink = document.getElementById('contract-summary-link');
     }
     setup() {
        window.onload = () => {
            this.contractSummaryLink.style.display = 'none';
            this.startLoad();
        };
    }
    
    startLoad() {
        this.section.classList.add(constants.SPINNER_ACTIVE);
        this.section.classList.add('hide-inner');
        $.ajax({
            url: '/checkout/load-pcsi-action',
            success: (data) => {
                this.contractSummaryLink.setAttribute('href', data);
                this.contractSummaryLink.style.display = 'block';
                this.endLoad();
            }
        });
    }
    
    endLoad() {
        this.section.classList.remove(constants.SPINNER_ACTIVE);
        this.section.classList.remove('hide-inner');
    }
}
